import React from 'react'

const getMediaLabel = function(attachment) {
  var result = capitalize(attachment.type)
  if(attachment.size_details && attachment.size_details.trim().length > 0) {
    result = result + ' | ' + attachment.size_details
  }
  return <li>{result}</li>
}

const capitalize = function(string) {
  if(!string) return ''
  if(string === 'pdf') return 'PDF'
  return string.slice(0,1).toUpperCase() + string.slice(1, string.length)
}

export default getMediaLabel
